var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"rules":_vm.rules,"color":"primary","flat":"","chips":"","deletable-chips":"","items":_vm.rolItems,"value":_vm.$store.state.openUser.details.role,"multiple":"","clearable":"","label":"Rol"},on:{"input":function($event){return _vm.$store.commit('openUser/mutate', {
      property: 'details.role',
      with: $event
    })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }